import { Link } from '@utmb/design-system/link/link';
import { Font } from '@utmb/design-system/text/font';
import { ColorTypesEnum } from '@utmb/types/colors';
import { IconsEnum } from '@utmb/types/icons';
import { useTranslation } from 'next-i18next';
import { ReactElement } from 'react';
import styles from './not-attached-runner.module.scss';

export const NotAttachedRunner = (): ReactElement => {
    const { t } = useTranslation('myutmb');
    return (
        <div className={styles.container}>
            <Font.FuturaMedium className={styles.text_helper} mobile="22" desktop="26">
                {t('myUtmb.attachRunner.textHelper')}
            </Font.FuturaMedium>
            <Link.Button
                variant={IconsEnum.RIGHT}
                composeClassName={styles.cta}
                href={`/utmb-index/runner-search`}
                label={t('myUtmb.attachRunner.buttonLabel')}
                color={ColorTypesEnum.WS_SECONDARY}
                bgcolor={ColorTypesEnum.WS_PRIMARY}
            />
        </div>
    );
};
